import type { UploadedFile } from 'models';
import { Button } from 'ui';
import { useDownloadFilesAsZip } from '../../../queries';

type P = {
  attachments: UploadedFile[];
};

const SaveAttachmentsAsZipButton = ({ attachments }: P) => {
  const { isPending: isLoading, mutate: handleSave } = useDownloadFilesAsZip();

  return (
    <Button
      loading={isLoading}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        handleSave({
          files: attachments.map((attachment) => ({ fileName: attachment.filename, url: attachment.downloadUrl })),
        });
      }}
      type="link-primary"
    >
      Save all
    </Button>
  );
};

export default SaveAttachmentsAsZipButton;
